import checkIcon from '@/assets/images/icon/check-active.svg';
import inactiveCheckIcon from '@/assets/images/icon/check-inactive.svg';

const ActiveOrInactiveIcon = ({ isActive }: { isActive: boolean }) => {
  return (
    <img
      className="size-4 lg:size-6 mx-auto object-cover"
      src={isActive ? checkIcon : inactiveCheckIcon}
      alt={isActive ? 'active' : 'inactive'}
      loading="lazy"
    />
  );
};

export { ActiveOrInactiveIcon };
